class Product{constructor(){this.acc=[],this.container=document.querySelector(".m-main-product"),MinimogTheme.CompareProduct&&MinimogTheme.CompareProduct.setCompareButtonsState(),MinimogTheme.Wishlist&&MinimogTheme.Wishlist.setWishlistButtonsState(),this.addRecentViewedProduct(),addEventDelegate({context:this.container,selector:(window.__minimog_review_selector||"")+".m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview",handler:e=>{const t=e.target.closest(".m-product-collapsible").dataset.index;setTimeout((()=>{this.acc[Number(t)].setContentHeight()}),300)},capture:!0})}addRecentViewedProduct(){const e=getCookie("m-recent-viewed-products");let t=e?JSON.parse(e):[];-1===t.indexOf(MinimogSettings.productHandle)&&(t.unshift(MinimogSettings.productHandle),t=t.slice(0,20),setCookie("m-recent-viewed-products",JSON.stringify(t)))}}


document.addEventListener("DOMContentLoaded", function () {
  function initMinimogVideoAutoplay() {
    const gallery = document.querySelector(".product-gallery__main");

    if (!gallery) return;

    // Wait for Flickity to be ready
    const flkty = Flickity.data(gallery);
    if (!flkty) {
      setTimeout(initMinimogVideoAutoplay, 300);
      return;
    }

    function handleVideoAutoplay() {
      const cells = gallery.querySelectorAll(".product-gallery__item");

      cells.forEach((cell, index) => {
        const video = cell.querySelector("video");

        if (!video) return;

        // Prepare video attributes
        video.muted = true;
        video.playsInline = true;
        video.loop = true;
        video.setAttribute("muted", "");
        video.setAttribute("playsinline", "");
        video.setAttribute("loop", "");

        const overlay = cell.querySelector(".product-media__play-button");
        if (overlay) overlay.style.display = "none"; // remove PLAY icon

        if (index === flkty.selectedIndex) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }

    // Run when slide changes
    flkty.on("select", handleVideoAutoplay);

    // Run once on load
    handleVideoAutoplay();
  }

  initMinimogVideoAutoplay();

  // Reload on variant change or AJAX load
  document.addEventListener("variant:changed", initMinimogVideoAutoplay);
  document.addEventListener("shopify:section:load", initMinimogVideoAutoplay);
});
